const vapidKey = 'BJHEBKAbuu1F0WiAwCmmK3H2-J2ivx9tOyo9dA5dkgYl5WjcA9-1iCHd2SP-1W8OzNEU8APE7NO82fasQh5mMGk'

const firebaseConfig = {
  apiKey: 'AIzaSyCKlinFPGcG1E2kUadrEA3hclHmDUJYksQ',
  authDomain: 'tayhanoi-lms.firebaseapp.com',
  projectId: 'tayhanoi-lms',
  storageBucket: 'tayhanoi-lms.firebasestorage.app',
  messagingSenderId: '207027468798',
  appId: '1:207027468798:web:934955b436a6c34b90e8af',
  measurementId: 'G-PC8RDGYPPR'
}

export { vapidKey, firebaseConfig }
